module.exports = __webpack_public_path__ + "images/flag-sweden_58fe3d8f30ce98304617858fc9ce4f83.svg";